export default {
  primary: "#673ab7", //deep purple 500
  secondary: "#7e57c2", // deep purple 400
  tertiary: "#b39ddb", //deep purple 200
  accent: "#ff4081", //pink a200
  error: "#b71c1c", //red 900
  info: "#00acc1", //cyan 500
  success: "#512daB", //deep purple 700
  warning: "#f57c00", // orange 700
};
